module.exports = __webpack_public_path__ + "static/media/hero4.b5556fc9.jpeg";